import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Spin, Table } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getInvoiceList, getInvoiceTypes } from '../../service/invoice';
import './index.scss';


class InvoiceList extends Component {
    state = {
        listData: {},
        loading: false,
        organization: [],
        accountAccess: undefined,
        query: {

            pageIndex: 1,
            pageSize: 10,
            beginTime: undefined,
            endTime: undefined,
            agentId: undefined,
            orgAccount: undefined,
            searchStr: undefined,
            type: undefined,
            orderBy: undefined,
            order: undefined,
            beginTimeForElement: undefined,
            endTimeForElement: undefined
        },
        visible: false,
        record: {},
        invoiceTypes: []
    }

    componentDidMount() {
        getInvoiceTypes().then(res => {
            this.setState({
                invoiceTypes: res.result
            })
        })
    }

    changePage(current) {

        const query = this.state.query
        query.pageIndex = current

        this.setState({
            query
        }, () => {
            this.getList()
        })


    }
    getList() {
        this.setState({
            loading: true
        })
        axios({
            method: 'get',
            url: `/api/invoice`,
            params: { ...this.state.query, agentId: this.props.currentAgent._id }
        }).then(res => {
            if (res.data.errCode === 0) {

                this.setState({
                    listData: res.data.result,
                    loading: false
                }, () => {
                })
            } else {
                message.error(res.data.errInfo)
            }



        }).catch(err => {
            this.setState({
                loading: false
            })

        })
    }
    changeTime = (value, dateString) => {


        const query = this.state.query
        if (value && value.length > 0) {
            query.beginTime = value[0].startOf('day').unix()
            query.endTime = value[1].endOf('day').unix()
            query.beginTimeForElement = value[0]
            query.endTimeForElement = value[1]
        } else {
            query.beginTime = undefined
            query.endTime = undefined
            query.beginTimeForElement = undefined
            query.endTimeForElement = undefined
        }


        this.setState({
            query
        })
    }

    handleChangeSearchStr = (e) => {
        const query = { ...this.state.query, searchStr: e.target.value }
        this.setState({
            query
        })

    }
    handleChangeOrgAccount = (value) => {
        const query = { ...this.state.query, orgAccount: value }
        this.setState({
            query
        })
    }



    handleSearch = (value) => {



        this.getList()


    }
    handleReset = () => {
        const query = {
            pageIndex: 1,
            pageSize: 10,
            beginTime: undefined,
            endTime: undefined,
            agentId: undefined,
            orgAccount: undefined,
            searchStr: undefined,
            type: undefined,
            orderBy: undefined,
            order: undefined,
            beginTimeForElement: undefined,
            endTimeForElement: undefined
        }
        this.setState({
            query
        }, () => {
            this.getList()
        })
    }
    handleExport = () => {
        this.setState({
            loading: true
        })
        axios({
            url: `/api/invoice/download`,
            method: 'get',
            params: { ...this.state.query, agentId: this.props.currentAgent._id }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.downloadFile(res.data.result)
            }
            this.setState({
                loading: false
            })

        }).catch(err => {
            this.setState({
                loading: false
            })
            message.error('导出失败');
        })

    }
    downloadFile = (url) => {
        try {
            const elemIF = document.createElement("iframe");
            elemIF.src = url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
            elemIF.onload = function () {

            };
        } catch (e) {

        }
    }
    handleTableChange = (pagination, filters, sorter) => {


        const query = { ...this.state.query, pageIndex: pagination.current, type: filters.type && filters.type.join(), orderBy: sorter.field, order: sorter.order }

        this.setState({
            query
        }, () => {
            this.getList()
        })

    };
    UNSAFE_componentWillMount() {
        this.getList()
        // 其他地方复制的业务代码
        const { currentAgent } = this.props
        if (currentAgent && currentAgent.agentRole && currentAgent.agentRole.level == '2') {
            let tenant = currentAgent.tenant ? currentAgent.tenant._id : ''
            let orgAccount = currentAgent.orgAccount ? currentAgent.orgAccount._id : ''
            const query = this.state.query
            query.orgAccount = orgAccount
            this.setState({
                query
            })

            this.setState({

                accountAccess: '2'
            })

        }
        this.getOrganization()
    }

    getOrganization = () => {
        const { currentAgent } = this.props
        const tenant = currentAgent.tenant ? currentAgent.tenant._id : ''
        axios({
            url: `/api/lossAss/organizitions/simple?pageIndex=1&pageSize=1000&searchTenant=${tenant}`,
            method: 'get',

        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    organization: res.data.result.list
                })
            }


        }).catch(err => {

            message.error(err.message)
        })
    }

    view = (record) => {

        this.setState({
            record
        })
        this.showModal()

    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const { query, organization, accountAccess, record, invoiceTypes } = this.state;
        const columns = [

            {
                title: '客户名称',
                dataIndex: 'customerName',
                key: 'customerName',

            },
            {
                title: '发票类型',
                dataIndex: 'type',
                key: 'type',
                render: (text, record) => <span>{invoiceTypes.find(item => item.type === text)?.name}</span>,
                filters: invoiceTypes.map(item => ({ text: item.name, value: item.type }))
            },
            {
                title: '纳税人识别号或统一社会信用代码',
                dataIndex: 'serialNo',
                key: 'serialNo',
            },
            // {
            //     title: '投保人代码',
            //     dataIndex: 'aptCode',
            //     key: 'aptCode',
            // },
            // {
            //     title: '地址',
            //     dataIndex: 'address',
            //     key: 'address',
            // },
            // {
            //     title: '电话',
            //     dataIndex: 'phone',
            //     key: 'phone',
            // },
            {
                title: '账号',
                dataIndex: 'account',
                key: 'account',
            },
            {
                title: '开户银行',
                dataIndex: 'accountBank',
                key: 'accountBank',
            },
            {
                title: '开票月份',
                dataIndex: 'applyMonth',
                key: 'applyMonth',
                render: text => text && dayjs(text).format('YYYY-MM')
            },

            {
                title: '提交时间',
                dataIndex: 'ctime',
                key: 'ctime',
                sorter: true,
                render: text => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
            },

            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',

                render: (text, record) => {
                    return <div>
                        <Button type="link" onClick={() => this.view(record)}>查看</Button>

                    </div>
                }
            },





        ];
        const paginationProps = {

            showQuickJumper: false,
            showTotal: () => `共${this.state.listData.count}条`,
            pageSize: 10,
            current: this.state.query.pageIndex,
            total: this.state.listData.count,
            showSizeChanger: false

            // onChange: (current) => this.changePage(current),
        };

        return (
            <div className='invoice-list-container' style={{
                width: '100%',
                height: '100%',
                overflowX: 'hidden',
                overflowY: 'auto',
                background: '#fff',
                padding: 20
            }}>
                <Row>
                    <Col span={24}>
                        <div >
                            <DatePicker.RangePicker
                                allowClear
                                format="YYYY-MM-DD"
                                placeholder={['起始日期', '终止日期']}
                                showTime={{
                                    hideDisabledOptions: true,
                                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                                }}
                                onChange={this.changeTime} style={{ marginLeft: 20, width: 350 }}
                                value={query.beginTimeForElement && query.endTimeForElement ? [query.beginTimeForElement, query.endTimeForElement] : []}

                            />


                            <Select
                                disabled
                                defaultValue='太平洋保险'
                                style={{ width: 350, marginLeft: 20 }} >
                                <Select.Option key='太平洋保险' value='太平洋保险'>太平洋保险</Select.Option>
                            </Select>
                            <Select value={query.orgAccount} disabled={accountAccess && accountAccess == '2'} allowClear placeholder='全部机构' style={{ width: 350, marginLeft: 20 }} onChange={this.handleChangeOrgAccount}>
                                {organization.map((item, index) => <Select.Option key={index} value={item._id}>{item.orgName}</Select.Option>)}
                            </Select>



                        </div>
                        <div style={{ height: 20 }}></div>
                        <div>
                            <Input
                                value={query.searchStr}
                                onChange={this.handleChangeSearchStr}
                                placeholder='请输入客户名称、纳税人识别码或统一社会信用代码'
                                style={{ width: 350, marginLeft: 20 }}
                            />
                        </div>

                    </Col>

                </Row>
                <div style={{ height: 20 }}></div>
                <Row >
                    <Col span={24}>
                        <Button style={{ marginLeft: 20 }} onClick={this.handleSearch} type="primary"   >
                            查询
                        </Button>
                        <Button style={{ marginLeft: 20 }} onClick={this.handleReset} type="primary"   >
                            重置
                        </Button>
                        <Button style={{ marginLeft: 20 }} onClick={this.handleExport} type="primary" icon={<i className="iconfont icon-download" />} >
                            导出
                        </Button>
                    </Col>
                </Row>
                <div style={{ height: 20 }}></div>
                <Spin spinning={this.state.loading}>
                    <Table pagination={paginationProps}
                        rowKey="id"
                        columns={columns}
                        dataSource={this.state.listData.list}
                        onChange={this.handleTableChange}
                    />
                </Spin>

                <Modal
                    title="发票详情"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                    width='70%'
                >
                    <div>
                        <div className='flex-box'>
                            <div className='flex-item'>
                                <span className='invoice-label'>客户名称:</span>
                                <span className='invoice-value'>{record.customerName}</span>
                            </div>
                            <div className='flex-item'>
                                <span className='invoice-label'>发票类型:</span>
                                <span className='invoice-value'>{invoiceTypes.find(item => item.type === record.type)?.name}</span>
                            </div>
                        </div>

                        <div className='subhead'>
                            <span className='blue-line'></span><h3 className='title'>发票信息收集</h3>
                        </div>

                        <div className='flex-box'>
                            <div className='flex-item'>
                                <span className='invoice-label'>纳税人识别号或统一社会信用代码:</span>
                                <span className='invoice-value'>{record.serialNo}</span>
                            </div>
                            {
                                ['vat', 'digitalVat'].includes(record.type) ? <div className='flex-item'>
                                    <span className='invoice-label'>公司注册地址:</span>
                                    <span className='invoice-value'>{record.address}</span>
                                </div> : null
                            }
                        {
                            ['vat', 'digitalVat'].includes(record.type) ? <React.Fragment>
                                    <div className='flex-item'>
                                        <span className='invoice-label'>公司注册电话:</span>
                                        <span className='invoice-value'>{record.phone}</span>
                                    </div>
                                    <div className='flex-item'>
                                        <span className='invoice-label'>账号:</span>
                                        <span className='invoice-value'>{record.account}</span>
                                    </div>
                                    <div className='flex-item'>
                                        <span className='invoice-label'>开户银行:</span>
                                        <span className='invoice-value'>{record.accountBank}</span>
                                    </div>
                            </React.Fragment> : null
                        }
                            <div className='flex-item'>
                                <span className='invoice-label'>MINOS ID:</span>
                                <span className='invoice-value'>{record.minosid}</span>
                            </div>
                            <div className='flex-item'>
                                <span className='invoice-label'>申请开票月份:</span>
                                <span className='invoice-value'>{record.applyMonth && dayjs(record.applyMonth).format('YYYY-MM')}</span>
                            </div>
                        </div>

                        <div className='subhead'>
                            <span className='blue-line'></span><h3 className='title'>发票邮寄地址收集</h3>
                        </div>

                        <div className='flex-box'>
                            <div className='flex-item'>
                                <span className='invoice-label'>联系人姓名:</span>
                                <span className='invoice-value'>{record.mailingInfo?.name}</span>
                            </div>
                            <div className='flex-item'>
                                <span className='invoice-label'>联系人电话:</span>
                                <span className='invoice-value'>{record.mailingInfo?.phone}</span>
                            </div>
                            <div className='flex-item'>
                                <span className='invoice-label'>联系人邮箱:</span>
                                <span className='invoice-value'>{record.mailingInfo?.email}</span>
                            </div>
                            <div className='flex-item'>
                                <span className='invoice-label'>发票邮寄地址:</span>
                                <span className='invoice-value'>{record.mailingInfo?.address}</span>
                            </div>
                        </div>
                    </div>


                </Modal>


            </div>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        agents: state.app.agents.queryList,
        app: state.app,
        currentAgent: state.app.currentAgent.userInfo,

    }
};
export default connect(
    mapStateToProps,


)(InvoiceList)


